export default __webpack_public_path__ + "static/media/dustbin.2837b582.svg";